import { Box, Text } from '@fullstory/components';
import React, { FC } from 'react';
import {
  BOX_WIDTH,
  LINK_LENGTH,
  JOINT_WIDTH,
  BOX_LEFT_RIGHT_MARGIN,
  CHART_WIDTH,
  CHART_HEIGHT,
  CHART_TOP_PADDING,
  BOX_HEIGHT,
  BOX_TOP_MARGIN,
  JOINT_OFFSET,
} from './const';
import css from './index.module.scss';
import { makePath } from './util';
import { FormattedMessage } from 'react-intl';

export const EmptyDiagram: FC<{ width: number }> = ({ width }) => {
  const offset = BOX_WIDTH + LINK_LENGTH + (JOINT_WIDTH + BOX_LEFT_RIGHT_MARGIN) * 2;
  const chartMargins = width ? (width - CHART_WIDTH) / 2 : 0;

  const entryLeftMargin = BOX_LEFT_RIGHT_MARGIN + chartMargins + BOX_LEFT_RIGHT_MARGIN;
  const pageLeftMargin = chartMargins + offset + JOINT_OFFSET;
  const exitLeftMargin = chartMargins + offset * 2 + JOINT_OFFSET;
  const firstBoxYPos = CHART_TOP_PADDING * 3;
  const pathWidth = 20;
  const pathOffset = pathWidth / 2;

  return (
    <svg data-component="EmptyDiagram" width={width} height={CHART_HEIGHT} className={css.block}>
      <defs>
        <filter id="pageNodeFilter">
          <feDropShadow floodOpacity={0.2} floodColor="currentColor" />
        </filter>
      </defs>
      <g>
        <rect width="100%" height={CHART_HEIGHT} className={css.visualizationBackground} />
        <>
          <foreignObject x={entryLeftMargin} width={BOX_WIDTH - 12} height={200}>
            <Box marginLeft={12} marginTop={CHART_TOP_PADDING}>
              <Text appearance="bodyMediumBold" color="default">
                <FormattedMessage defaultMessage="Previous page" id="k9hDFZ" />
              </Text>
            </Box>
          </foreignObject>

          <foreignObject x={pageLeftMargin} width={BOX_WIDTH - 12} height={200}>
            <Box marginLeft={12} marginTop={CHART_TOP_PADDING}>
              <Text appearance="bodyMediumBold" color="default">
                <FormattedMessage defaultMessage="This page" id="qRGjWq" />
              </Text>
            </Box>
          </foreignObject>

          <foreignObject x={exitLeftMargin} width={BOX_WIDTH - 12} height={200}>
            <Box marginLeft={12} marginTop={CHART_TOP_PADDING}>
              <Text appearance="bodyMediumBold" color="default">
                <FormattedMessage defaultMessage="Next page" id="rBj9Ib" />
              </Text>
            </Box>
          </foreignObject>
        </>
        <rect
          x={entryLeftMargin}
          y={firstBoxYPos}
          width={BOX_WIDTH}
          height={BOX_HEIGHT}
          rx="4"
          className={css.page}
          style={{ filter: 'url(#pageNodeFilter)' }}
        />
        <rect
          x={entryLeftMargin}
          y={firstBoxYPos + BOX_HEIGHT + BOX_TOP_MARGIN}
          width={BOX_WIDTH}
          height={BOX_HEIGHT}
          rx="4"
          className={css.page}
          style={{ filter: 'url(#pageNodeFilter)' }}
        />

        {/** paths from the ends of the Previous Page nodes to the start of the page flow node */}
        <path
          className={css.path}
          strokeWidth={pathWidth}
          d={makePath(
            entryLeftMargin + BOX_WIDTH + BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset,
            pageLeftMargin - BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset,
          )}
        />
        <path
          className={css.path}
          strokeWidth={pathWidth}
          d={makePath(
            entryLeftMargin + BOX_WIDTH + BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + BOX_HEIGHT + BOX_TOP_MARGIN + pathOffset,
            pageLeftMargin - BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset + pathWidth,
          )}
        />

        <rect
          x={pageLeftMargin}
          y={firstBoxYPos}
          width={BOX_WIDTH}
          height={BOX_HEIGHT}
          rx="4"
          className={css.page}
          style={{ filter: 'url(#pageNodeFilter)' }}
        />

        {/** paths from the ends of the page flow node to the start of the Next Page nodes */}
        <path
          className={css.path}
          strokeWidth={pathWidth}
          d={makePath(
            pageLeftMargin + BOX_WIDTH + BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset,
            exitLeftMargin - BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset,
          )}
        />
        <path
          className={css.path}
          strokeWidth={pathWidth}
          d={makePath(
            pageLeftMargin + BOX_WIDTH + BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + pathOffset + pathWidth,
            exitLeftMargin - BOX_LEFT_RIGHT_MARGIN,
            firstBoxYPos + BOX_HEIGHT + BOX_TOP_MARGIN + pathOffset,
          )}
        />

        <rect
          x={exitLeftMargin}
          y={firstBoxYPos}
          width={BOX_WIDTH}
          height={BOX_HEIGHT}
          rx="4"
          className={css.page}
          style={{ filter: 'url(#pageNodeFilter)' }}
        />
        <rect
          x={exitLeftMargin}
          y={firstBoxYPos + BOX_HEIGHT + BOX_TOP_MARGIN}
          width={BOX_WIDTH}
          height={BOX_HEIGHT}
          rx="4"
          className={css.page}
          style={{ filter: 'url(#pageNodeFilter)' }}
        />
      </g>
    </svg>
  );
};
